import type { ReactNode } from 'react'
import { useAuth } from '../auth/AuthContext'

interface PermissionGateProps {
  anyOf: string[]
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Blendet UI nur aus Usability-Gründen aus — ersetzt NICHT die serverseitige
 * Rechteprüfung (siehe backend/src/middleware/authorize.ts). Ein Request gegen einen
 * ausgeblendeten Endpunkt wird vom Server trotzdem mit 403 abgelehnt.
 */
export function PermissionGate({ anyOf, children, fallback = null }: PermissionGateProps) {
  const { hasAnyPermission } = useAuth()
  return hasAnyPermission(anyOf) ? <>{children}</> : <>{fallback}</>
}
